/**
 * Collective Chapter Scroll Tracking
 * Highlights the current section in the side menu as the user scrolls
 */

export const collectiveChapterScroll = (() => {
    // Only run on pages with the collective chapter structure
    const chapterSections = document.querySelectorAll('.collective-digital--chapter');
    const sideMenu = document.querySelector('.sideMenu');

    if (!chapterSections.length || !sideMenu) {
        return;
    }

    function setupIntersectionObserver(sections, sideMenuElement) {
        const options = {
            root: null,
            rootMargin: '-100px 0px -60% 0px', // Trigger when section is near top of viewport
            threshold: 0
        };

        const observerCallback = (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const anchor = entry.target.querySelector('.anchor');
                    if (anchor && anchor.id) {
                        updateActiveMenuItem(anchor.id, sideMenuElement);
                    }
                }
            });
        };

        const observer = new IntersectionObserver(observerCallback, options);
        sections.forEach(section => observer.observe(section));
    }

    function updateActiveMenuItem(anchorId, sideMenuElement) {
        // Remove current class from all menu items
        const currentItems = sideMenuElement.querySelectorAll('.sideMenu-button--current');
        currentItems.forEach(item => {
            item.classList.remove('sideMenu-button--current');
        });

        // Add current class to the matching menu item
        const targetLink = sideMenuElement.querySelector(`.sideMenu-button[href$="#${anchorId}"]`);
        if (targetLink) {
            targetLink.classList.add('sideMenu-button--current');

            // Ensure parent chapter is open
            ensureParentOpen(targetLink);
        }
    }

    function ensureParentOpen(menuItem) {
        // Find the parent submenu container
        const subLevel = menuItem.closest('.sideMenu-subLevel');
        if (subLevel) {
            const parentButton = subLevel.previousElementSibling;
            if (parentButton && parentButton.classList.contains('sideMenu-button')) {
                parentButton.classList.add('open');
                parentButton.setAttribute('aria-expanded', 'true');
            }
        }
    }

    function handleInitialHash() {
        // If page loads with a hash, highlight that menu item immediately
        const hash = window.location.hash;
        if (hash) {
            const anchorId = hash.substring(1); // Remove the # symbol
            updateActiveMenuItem(anchorId, sideMenu);
        }
    }

    // Initialize
    setupIntersectionObserver(chapterSections, sideMenu);
    handleInitialHash();
})();

/**
 * Content list toggle
 * Shows first 10 items in the table of contents and toggles the rest
 */

export const collectiveContentListToggle = (() => {
    const list = document.querySelector(".collective-digital--contentlist");
    if (!list) return;
  
    const maxVisible = 5;
  
    // Alla li i listan
    const allItems = Array.from(list.querySelectorAll("li"));
  
    // Header är första li med klassen collective-digital--contentheader
    const headerItem = list.querySelector(".collective-digital--contentheader");
  
    // Rader som faktiskt ska räknas är alla li förutom header
    const contentItems = allItems.filter((li) => li !== headerItem);
  
    if (contentItems.length <= maxVisible) return;
  
    const toggleLi = document.createElement("li");
    const toggleBtn = document.createElement("button");
  
    toggleBtn.type = "button";
    toggleBtn.className = "collective-digital--contenttoggle btn btn--sm btn--ghost";
    toggleBtn.setAttribute("aria-expanded", "false");
    toggleBtn.textContent = "Visa alla";
  
    toggleLi.appendChild(toggleBtn);
    list.appendChild(toggleLi);
  
    function applyCollapsedState() {
      contentItems.forEach((li, index) => {
        if (index >= maxVisible) {
          li.hidden = true;
        } else {
          li.hidden = false;
        }
      });
  
      toggleBtn.textContent = "Visa alla";
      toggleBtn.setAttribute("aria-expanded", "false");
      if (window.recalcSidebarLayout) window.recalcSidebarLayout();
    }
  
    function applyExpandedState() {
      contentItems.forEach((li) => {
        li.hidden = false;
      });
  
      toggleBtn.textContent = "Visa färre";
      toggleBtn.setAttribute("aria-expanded", "true");
      if (window.recalcSidebarLayout) window.recalcSidebarLayout();
    }
  
    // Startläge
    let isExpanded = false;
    applyCollapsedState();
  
    toggleBtn.addEventListener("click", () => {
      isExpanded = !isExpanded;
  
      if (isExpanded) {
        applyExpandedState();
      } else {
        applyCollapsedState();
  
        // Skrolla gärna tillbaka till början av listan så man inte hamnar mitt i
        list.scrollIntoView({ block: "nearest" });
      }
    });
  })();
  